import JobSeekerResumeFiles from '@/components/FileUpload/JobSeekerResumeFiles'
import { memo } from 'react'
import { isEmpty } from 'lodash'
import { type V1ResumeComponent } from 'mnvm-mypage-app-ts-if'
import { downloadFile } from '@/feature/JobPosting/common'

interface Props {
  component: V1ResumeComponent
}

const JobSeekerResumeContainer = ({ component }: Props): JSX.Element => {
  const files = component.uploadedResumeFile
  return isEmpty(files) ? (
    <></>
  ) : (
    <JobSeekerResumeFiles
      files={files ?? []}
      onDownload={(url) => {
        downloadFile(url)
      }}
    />
  )
}

export default memo(JobSeekerResumeContainer)
